// DTO recebido via FCM push (somente leitura, nao e enviado ao backend)
// Nota: FCM data messages exigem todos os valores como string. estadoAnterior e "" em NOVO_PEDIDO (nao null).
export interface NotificacaoPedidoDTO {
  tipo: TipoNotificacaoPedido;
  pedidoId: number;
  codigoDePedido: string;
  nomeCliente: string;
  estadoAnterior: string;
  estadoAtual: string;
  timestamp: string; // ISO 8601
  /** Opcional: RETIRADA_NO_LOCAL | DELIVERY. Ausente quando o backend nao envia no push. */
  tipoEntrega?: string;
}

// Tipos de notificacao de pedido
export enum TipoNotificacaoPedido {
  NOVO_PEDIDO = 'NOVO_PEDIDO',
  MUDANCA_ESTADO = 'MUDANCA_ESTADO',
}
